import { ToastService } from '@philips-internal/oswald-ui-components';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';

export default class ShowToast {

  public static open(message: string, typeMessage: ToastLevel): void {
    ToastService.open({
      dismissExpression: message,
      dismissible: true,
      highlight: false,
      id: 'toast-service',
      level: typeMessage,
      message: message,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    });
  }
}
